import { createFormStoreEvents } from '../../create-form-store-events';

export const offshorePositionAndWeatherEvents = createFormStoreEvents('offshorePositionAndWeatherFormStore');
